import { MARQUEE_ITEMS } from "@/data/site";

// Slow editorial marquee strip.
export default function Marquee({ items = MARQUEE_ITEMS, dark = false }) {
  const list = [...items, ...items];
  return (
    <div
      className={`relative overflow-hidden border-y ${
        dark ? "border-white/10 bg-navy-deep" : "border-slate-200/70 bg-surface"
      } py-5`}
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee gap-10 pr-10">
        {list.map((item, i) => (
          <div key={i} className="flex shrink-0 items-center gap-10">
            <span
              className={`font-heading text-lg font-semibold tracking-tight sm:text-xl ${
                dark ? "text-white/90" : "text-navy"
              }`}
            >
              {item}
            </span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              className={dark ? "text-brand-light" : "text-brand"}
              fill="none"
            >
              <path
                d="M4 14 L14 4 M14 4 H7 M14 4 V11"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
}
